import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import get from 'lodash/get';

function Head(props) {
  const meta = get(props, 'meta.meta') || [];
  const link = get(props, 'meta.link') || [];
  const title = get(props, 'meta.title');

  return (
    <head>
      <meta charset="utf-8" />
      <meta property="op:markup_version" content="v1.0" />
      <link rel="canonical" href={this.props.canonical} />
      <meta
        name="viewport"
        content="width=device-width,minimum-scale=1,initial-scale=1"
      />
      <title>{title}</title>
      <meta property="fb:article_style" content={this.props.articleStyle} />
      {meta.map(function createMetaTags(conf) {
        return <meta key={JSON.stringify(conf)} {...conf} />;
      })}
      {link.map(function createLinkTags(conf) {
        return <link key={JSON.stringify(conf)} {...conf} />;
      })}
    </head>
  );
}

function mapStateToProps(state) {
  return {
    articleStyle: 'TEST ARTICLE STYLE',
    canonical: state.config.navHistory[0].split('?')[0],
    staticUrl: state.config.staticUrl,
    meta: state.meta,
    initialPageLoad: state.config.initialPageLoad
  };
}

Head.propTypes = {
  // eslint-disable-next-line react/no-unused-prop-types
  meta: PropTypes.shape({}).isRequired
};

export default connect(mapStateToProps)(Head);



// WEBPACK FOOTER //
// ./src/views/components/head/fbia_head.js